import {page} from "@wordpress/icons";
import { useBlockProps, InnerBlocks, BlockControls, store as BlockEditorStore } from '@wordpress/block-editor';
import { useSelect, dispatch } from '@wordpress/data';
import {__, sprintf} from "@wordpress/i18n";
import { Placeholder, ToolbarGroup, Tip, Button } from '@wordpress/components';
import { Component } from '@wordpress/element';
import {templates} from "choices.js";
import {withDispatch, withSelect} from "@wordpress/data";
import Inspector from "./inspector";
import { useState, useEffect } from '@wordpress/element';

export const edit = ( props ) => {
    const [ isEditing, setEditing ] = useState(false );

    const innerBlocks = useSelect( ( select ) => {
        const { getBlock, getBlockName, getBlockAttributes } = select( BlockEditorStore );

        return getBlock( props.clientId );
    });

    console.log(innerBlocks.innerBlocks);
    console.log(InnerBlocks);

    const {
        attributes,
        isSelected,
        setAttributes,
    } = props;

    const {
        postsPerPage,
    } = attributes;

    const blockProps = useBlockProps();

    const togglePreview = () => {
        setEditing( ! isEditing );
    };

    const getBlockControls = () => {
        return (
            <BlockControls>
                <ToolbarGroup
                    controls={ [
                        {
                            icon: 'edit',
                            title: __(
                                'Edit inner product layout',
                                'realpress'
                            ),
                            onClick: () => togglePreview(),
                            isActive: isEditing,
                        },
                    ] }
                />
            </BlockControls>
        );
    };

    const renderEditMode = ( props ) => {
        const onDone = () => {
            togglePreview();
        };

        const onCancel = () => {
            togglePreview();
        };

        const onReset = () => {

        };

        const InnerBlockProps = {
            allowedBlocks: [ 'realpress/property-title', "realpress/property-price" ],
            template: [], // default templates
            templateLock: true, // default false
        };

        return (
            <div>
                <Tip>
                { __(
                    'Display item property on list properties.',
                    'realpress'
                ) }
                </Tip>
                <div className="wc-block-all-products-grid-item-template">
                    <InnerBlocks {...InnerBlockProps} />
                    <div className="wc-block-all-products__actions">
                        <Button
                            className="wc-block-all-products__done-button"
                            isPrimary
                            onClick={ onDone }
                        >
                            { __( 'Done', 'woocommerce' ) }
                        </Button>
                        <Button
                            className="wc-block-all-products__cancel-button"
                            isTertiary
                            onClick={ onCancel }
                        >
                            { __( 'Cancel', 'woocommerce' ) }
                        </Button>
                        <Button
                            className="wc-block-all-products__reset-button"
                            label={ __(
                                'Reset layout to default',
                                'woocommerce'
                            ) }
                            onClick={ onReset }
                        >
                            { __(
                                'Reset Layout',
                                'woocommerce'
                            ) }
                        </Button>
                    </div>
                </div>
            </div>
        );
    }

    const renderViewMode = ( attributes ) => {

        return (
            <div>
                <p>Posts per page: {postsPerPage}</p>

                {/*{innerBlocks.innerBlocks.map((el) => {{ __html: {
                    el.originalContent
                } }})}*/}

                {innerBlocks.innerBlocks.map((el) => {
                    const { attributes } = el;

                    return (
                        <div className="realpress-price-property" style={{ padding: "20px" }}>
                            <i style={{color: attributes?.color}}>Price property</i>
                        </div>
                    );


                })}
            </div>
        );
    }

    return (
        <div {...blockProps}>
            { getBlockControls() }

            <Placeholder>
                { isSelected && (
                    <Inspector
                        attributes={ attributes }
                        setAttributes={ setAttributes }
                    />
                ) }

                { isEditing ? renderEditMode( attributes ) : renderViewMode( attributes ) }
            </Placeholder>
        </div>
    );
};
